export class CurrentYear {
    constructor() {
        this.yearElement = document.querySelector('.current-year');
        this.init();
    }

    init() {
        if (this.yearElement) {
            this.yearElement.textContent = new Date().getFullYear();
        }
    }
}